import { CheckCircleOutlineRounded, DataUsage, DoDisturbOnOutlined } from "@mui/icons-material";
import { Box, Card, Stack, Typography } from "@mui/material";
import { stepLabel } from "src/careflow/ph-core/workflow/helpers/workflow";
import { useStyles } from "src/careflow/helpers/workflowStyle";

const iconSize = { width: 20, height: 20 };

const StepCard = ({ 
  active, 
  handlerGoToStep,
  stepStatus,
  step,
  allChecklist,
  indexStep,
  disabled,
  isLastStep,
  i18n
}: any) => {
  const classes = useStyles({});

  const { valid, total } = stepLabel(step?.id, allChecklist);
  const stepName = step?.name ? `${indexStep}. ${step.name}` : '';
  const stepSubLabel = `
    ${i18n('case.details.workflow.stepCountTitle', 'crs')} 
    ${valid}/${total}
  `;

  return (
    <Card
      id={`step-card-${step?.code}`}
      variant="outlined"
      className={classes.stepCard}
      sx={{
          p: 1,
          borderRadius: 1,
          borderColor: active ? '#212B36' : '',
        ...(disabled && !isLastStep && {
          background: '#f4f6f8',
          color: '#637381',
        }),
      }}
      onClick={handlerGoToStep}
    >
      <Stack
        sx={{ 
          px: '4px'
        }}
      >
        <Typography 
          variant="body1"
          sx={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            width: '100%',
          }}
        >
          {stepName}
        </Typography>
        <Box 
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            mt: 0.2
          }}
        >
          <Typography variant="caption" color="GrayText">
            {stepSubLabel}
          </Typography>
          <Box
            sx={{ justifySelf: 'flex-end' }}
          >
            {disabled || (isLastStep && !stepStatus) ? 
              <DoDisturbOnOutlined sx={{ ...iconSize, color: '#637381' }}/>
            : stepStatus
              ? <CheckCircleOutlineRounded sx={{ ...iconSize, color: '#007867' }} /> 
              : <DataUsage  sx={{ ...iconSize, color: '#006cff' }}/> 
            }
          </Box>
        </Box>
      </Stack>
     
    </Card>
  )
}

export default StepCard;